module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/drs/"},"frontmatter":{"title":"DRS"}}}]}},"pathContext":{"tag":"Drs"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-drs.json
// module id = 435
// module chunks = 201471480251666